<template>
  <b-col lg="10">
    <b-form-group class="text-left"
                  label-class="font-weight-bold pt-0">
     <p> <span style="font-weight: bold">{{label}}</span>
      <span class="small">// {{comment}} //</span></p>
      <b-form-group
          :id="`type-${node.codeQuestions}`"
          v-if="value[node.dependCodeQuestion] && value[node.dependCodeQuestion] !== ' '"
          label-cols-lg="3"
          description="Число от 0 до 100"
          :label="node.text"
          :label-for="`type-${node.codeQuestions}`"
          v-for="node in answers" :key="node.codeQuestions"
      >
        <b-form-input
            style="width: 80px"
            :id="`type-${node.codeQuestions}`"
            @input="changedText(node)"
            size="sm"
            type="text"
            max="3"
            min="0"
            v-model="node.point"/>
      </b-form-group>
    </b-form-group>
  </b-col>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'FormBalanced',
  props: {
    codeQuestion: {
      type: String,
      default: ''
    },
    textQuestion: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    comment: {
      type: String,
      default: ''
    },
    answers: {
      type: Array,
      default: () => {}
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      items: [
      ],
      sumItem: '0'
    }
  },
  beforeMount () {
    _.forEach(this.answers, (item) => {
      if (this.value[item.codeQuestions] &&
        this.value[item.codeQuestions] !== ' ') {
        item.point = this.value[item.codeQuestions]
      }
      if (item.text === 'Другое' && this.value[item.dependCodeQuestion]) {
        item.text = this.value[item.dependCodeQuestion]
      }
    })
  },
  methods: {
    changedValues () {
      const points = []
      _.forEach(this.answers, (node) => {
        if (node.point && node.point !== ' ') {
          points.push(parseInt(node.point, 10))
        }
      })
      this.sumItem = _.sum(points)
    },
    isShowed (item) {
      return this.value[item.codeQuestions] && this.value[item.codeQuestions] !== ' '
    },
    changedText (item) {
      console.log('changedText', item)
      const result = {codeQuestion: item.codeQuestions, value: item.point}
      this.$emit('action-output', result)
      this.changedValues()
    }
  }
}
</script>

<style scoped>
  .form-control .form-control-sm {
    width: 80px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/FormBalanced.vue